import React from 'react'
import PropTypes from 'prop-types'

const UsersList = ({
  users,
  onSelectUser,
  selectedUserId,
  className,
  onSearch,
  count,
  onRemoveUser
}) => (
  <div className={`form-group margin-top-10 ${className}`}>
    <label>Users ({count}):</label>
    <div className='input-group'>
      <input
        type='text'
        className='form-control'
        placeholder='Search'
        onChange={e => onSearch(e.target.value)}
      />
      <span className='input-group-btn'>
        <button className='btn red'>
          <i className='fa fa-search' />
        </button>
      </span>
    </div>
    <table className='table table-hover table-stripe'>
      <tbody style={{ border: '1px solid #eee' }}>
        {users.map(user => (
          <tr
            key={user.id}
            onClick={() => onSelectUser(user)}
            className={user.id === selectedUserId ? 'selectedRow' : ''}
            style={{ cursor: 'pointer' }}
          >
            <td style={{ width: 30 }} className='text-left'>
              {user.id === selectedUserId ? (
                <i className='fa fa-chevron-right' />
              ) : null}
            </td>

            <td className='text-left' key={user.id}>
              {user.screenName}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
    <a onClick={onRemoveUser} style={{ color: '#AA1616', fontWeight: 400 }}>
      Remove selected user from this tenant
    </a>
  </div>
)

UsersList.propTypes = {
  users: PropTypes.array.isRequired,
  count: PropTypes.number.isRequired,
  onSelectUser: PropTypes.func.isRequired,
  selectedUserId: PropTypes.string.isRequired,
  onSearch: PropTypes.func.isRequired,
  onRemoveUser: PropTypes.func.isRequired,
  className: PropTypes.string
}

export default UsersList



// WEBPACK FOOTER //
// ./src/pages/admin/permissions/tenant-permissions/users-list.js